import Types from "./Types";

const INITIAL_STATE = {
  studentPerGroup: [],
  performance: {},
  videosReport: [],
  homeworkUncomment: [],
  attendancesReport: [],
  examReport: [],
  unpaidReport: [],
  paidReport: [],
  examAttendance: [],
  homeworkAttendance: [],
  homeworkAbsent: [],
  savedMessages: [],
  isLoading: false,
  savedMessagesByReceiverPhone: [],
  savedMessagesByReceiverPhonePagination: {
    currentPage: 1,
    totalPages: 1,
    perPage: 10,
    total: 0,
    from: 0,
    to: 0,
  },
  manualExamMarks: [],
  telegramActiveUsers: [],
  telegramActiveUsersPagination: {
    currentPage: 1,
    totalPages: 1,
    perPage: 15,
    total: 0,
  },
  telegramInactiveUsers: [],
  telegramInactiveUsersPagination: {
    currentPage: 1,
    totalPages: 1,
    perPage: 15,
    total: 0,
  },
};

export default function reports(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.STUDENTS_PER_GROUP_SUCCESS: {
      return {
        ...state,
        studentPerGroup: payload.data,
      };
    }

    case Types.VIDEO_REPORT_SUCCESS: {
      return {
        ...state,
        videosReport: payload.data,
      };
    }

    case Types.UNPAID_REPORT_SUCCESS: {
      return {
        ...state,
        unpaidReport: payload.data.data,
      };
    }
    case Types.PAID_REPORT_SUCCESS: {
      return {
        ...state,
        paidReport: payload.data.data,
      };
    }
    case Types.ATTENDANCE_REPORT_SUCCESS: {
      return {
        ...state,
        attendancesReport: payload.data.data,
      };
    }

    // create
    case Types.EXAM_REPORT_SUCCESS: {
      return {
        ...state,
        examReport: payload.data?.data,
      };
    }
    case Types.EXAM_ATTENDANCE_SUCCESS: {
      return {
        ...state,
        examAttendance: payload.data,
      };
    }

    case Types.HOMEWORK_ATTENDENCE_REPORT_SUCCESS: {
      return {
        ...state,
        homeworkAttendance: payload.data?.data,
      };
    }
    case Types.HOMEWORK_UNCOMMENT_REPORT_SUCCESS: {
      return {
        ...state,
        homeworkUncomment: payload.data?.data,
      };
    }
    case Types.FILTER_HOMEWORK_ATTENDENCE_REPORT_SUCCESS: {
      return {
        ...state,
        homeworkAttendance: payload.data?.data,
      };
    }
    case Types.HOMEWORK_ABSENT_REPORT_SUCCESS: {
      return {
        ...state,
        homeworkAbsent: payload.data,
      };
    }

    case Types.DELETE_STUDENT_HOMEWORK_SUCCESS: {
      //console.log(payload);
      const newhomeworks = state.homeworkUncomment.filter(
        (item) => item.student_id !== payload.student_id
      );
      return {
        ...state,
        homeworkUncomment: newhomeworks,
      };
    }
    case Types.RESTRICT_STUDENT_HOMEWORK_REQUEST: {
      return {
        ...state,
      };
    }
    case Types.ACCEPT_STUDENT_HOMEWORK_SUCCESS: {
      return {
        ...state,
      };
    }
    case Types.COMMENT_STUDENT_HOMEWORK_SUCCESS: {
      const newhomeworks = state.homeworkUncomment.filter(
        (item) => item.id !== payload
      );
      return {
        ...state,
        homeworkUncomment: newhomeworks,
      };
    }
    case Types.STUDENT_PERFORMANCE_SUCCESS: {
      return {
        ...state,
        performance: payload.data,
      };
    }

    case Types.ADD_STUDENT_NOTE_SUCCESS: {
      // Note is added, performance will be refreshed by the saga
      return state;
    }

    case Types.REPORT_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case Types.CENTER_HW_SUCCESS: {
      return {
        ...state,
        centerHw: payload.data,
      };
    }

    case Types.VIDEO_ABSENCE_REPORT_SUCCESS: {
      return {
       ...state,
        videosReport: payload,
      };
    }

    case Types.VIDEO_ABSENCE_REPORT_LOADING: {
      return {
      ...state,
        isLoading: payload,
      };
    }

    case Types.MONTHLY_REPORT_SUCCESS: {
      return {
        ...state,
        monthlyReport: payload,
      };
    }

    case Types.SEND_BULK_CUSTOM_MESSAGE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.SEND_BULK_CUSTOM_MESSAGE_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.GET_SAVED_MESSAGES_BY_INTERVAL_SUCCESS: {
      return {
        ...state,
        savedMessages: payload.data?.data || payload.data || [],
      };
    }

    case Types.SEND_SAVED_MESSAGES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.SEND_SAVED_MESSAGES_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.NOTIFY_PARENT_FOR_EXAM_ABSENCE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.NOTIFY_PARENT_FOR_EXAM_ABSENCE_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.GET_MESSAGES_BY_RECEIVER_PHONE_SUCCESS: {
      return {
        ...state,
        savedMessagesByReceiverPhone: payload.data?.data?.data || payload.data?.data || [],
        savedMessagesByReceiverPhonePagination: {
          currentPage: payload.data?.data?.current_page || 1,
          totalPages: payload.data?.data?.last_page || 1,
          perPage: payload.data?.data?.per_page || 10,
          total: payload.data?.data?.total || 0,
          from: payload.data?.data?.from || 0,
          to: payload.data?.data?.to || 0,
        },
      };
    }

    case Types.GET_MESSAGES_BY_RECEIVER_PHONE_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }


    case Types.GET_MANUAL_EXAM_MARKS_SUCCESS: {
      return {
        ...state,
        manualExamMarks: payload.data?.data,
        isLoading: false,
      };
    }

    case Types.GET_MANUAL_EXAM_MARKS_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.GET_TELEGRAM_ACTIVE_USERS_SUCCESS: {
      return {
        ...state,
        telegramActiveUsers: payload.data?.users || [],
        telegramActiveUsersPagination: {
          currentPage: payload.data?.meta?.current_page || 1,
          totalPages: payload.data?.meta?.last_page || 1,
          perPage: payload.data?.meta?.per_page || 15,
          total: payload.data?.meta?.total || 0,
        },
        isLoading: false,
      };
    }

    case Types.GET_TELEGRAM_ACTIVE_USERS_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case Types.GET_TELEGRAM_INACTIVE_USERS_SUCCESS: {
      return {
        ...state,
        telegramInactiveUsers: payload.data?.users || [],
        telegramInactiveUsersPagination: {
          currentPage: payload.data?.meta?.current_page || 1,
          totalPages: payload.data?.meta?.last_page || 1,
          perPage: payload.data?.meta?.per_page || 15,
          total: payload.data?.meta?.total || 0,
        },
        isLoading: false,
      };
    }

    case Types.GET_TELEGRAM_INACTIVE_USERS_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    default: {
      return state;
    }
  }
}
